import React, {Component} from 'react'
import PropTypes from "prop-types";
import '../../components_style/rtl_css/FormElementContainer.css'
import '../../components_style/FormElementContainer.css'
import SvGraphics from "../../assets/SvGraphics";
import {authenticationService} from "../../services/AuthenticationService";

class TreatmentPlanNotExpanded extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded: this.props.isExpanded?this.props.isExpanded:false,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        this.setState({isExpanded:nextProps.isExpanded})
    }

    editTreatmentPlan = (func, value, index) => {
        this.props.editTreatmentPlan(func, value, index)
    }

    onClickArrow = () => {
        this.setState({isExpanded: !this.state.isExpanded})
    }

    DeleteTreatment(e,index) {
        e.stopPropagation()
        this.props.DeleteTreatment(index)
    }

    getSymptomsDesc = (Symptom_ID, lang) => {
        return this.props.getSymptomsDesc(Symptom_ID, lang)
    }

    getTreatmentInfo() {
        let current = this.props.current
        let {t} = this.props
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        if (current) {

            let treatmentSymptoms = []
            let symptoms = ""
            if (current.Symptom_ID && current.Symptom_ID.length > 0) {
                treatmentSymptoms = current.Symptom_ID
                for (let i = 0; i < treatmentSymptoms.length; i++) {
                    let symptomsDesc=this.getSymptomsDesc(treatmentSymptoms[i].toString(), language)
                    symptomsDesc=symptomsDesc?symptomsDesc:""
                    symptoms = symptoms + " " + symptomsDesc
                }
            }

            let intakeMethod = current.TreatmentIntakeMethod
            let variety = current.TreatmentVariety
            let treatmentSchedule = current.TreatmentSchedule
            if(language==="he"){
                treatmentSchedule=treatmentSchedule==="As needed"?"לפי צורך":treatmentSchedule
                treatmentSchedule=treatmentSchedule==="Maintenance"?"המשך טיפול":treatmentSchedule
                treatmentSchedule=treatmentSchedule==="Titration"?"טיטרציה":treatmentSchedule
                intakeMethod=intakeMethod==="Flower"?"פרח":intakeMethod
                intakeMethod=intakeMethod==="Oil drops"?"טיפות שמן":intakeMethod
                intakeMethod=intakeMethod==="Precision Dosing Devices"?"משאף למינון מדוד":intakeMethod
                intakeMethod=intakeMethod==="Other"?"אחר":intakeMethod
                variety=variety==="Indica"?"אינדיקה":variety
                variety=variety==="Sativa"?"סאטיבה":variety
                variety=variety==="Blend"?"זן היברידי":variety
                variety=variety==="Select All"?"אינדיקה, סאטיבה, זן היברידי":variety
            }else{
                variety=variety==="Select All"?"Indica, Sativa, Blend":variety
            }
            return (
                <div style={{display: 'flex',minWidth:'95%'}}>
                    <label className={"Treatment-symptomsInfo-label"}>{symptoms}</label>
                    <div className={"slash-div"}/>
                    <div className={"Treatment-Info-label"}>{intakeMethod}</div>
                    <div className={"Treatment-Info-label"}>{current.TreatmentCategory}</div>
                    <div className={"Treatment-Info-label"}>{variety}</div>
                    <div className={"Treatment-Info-label"}>{current.Treatment_plan_selected_product}</div>

                    <div className={"Treatment-Info-label"} style={{display:'flex'}}>
                        {current.TreatmentMonthlyDosage &&
                        <div style={{display:'flex'}}><label
                            className="treatment-plan-not-selected-value-bold">{current.TreatmentMonthlyDosage}</label>
                            <label
                                className="treatment-plan-not-selected-value"> {t('patient_boarding.gr_month')},</label>
                        </div>
                        }

                        {current.TreatmentInitialDose &&
                        <div style={{display:'flex'}}><label
                            className="treatment-plan-not-selected-value"> {t('patient_boarding.Initial_dose')},</label>
                            <label
                                className="treatment-plan-not-selected-value-bold">{current.TreatmentInitialDose} </label>
                        </div>
                        }
                        <label
                            className="treatment-plan-not-selected-value-bold">{treatmentSchedule}</label>
                    </div>


                </div>

            )
        }

    }

    render() {
        let {isExpanded} = this.state
        let {title, Component, rest, isSub,t} = this.props
        let treatmentIndex = this.props.treatmentIndex

        let symptomsInfo = this.getTreatmentInfo()
        return (
            <div
                className={isExpanded ? 'patientForm-box-container-Treatment' : 'patientForm-box-container patientForm-box-container-Treatment'}>
                <div style={{display: 'flex'}}>
                    <label className={'patientsFormBoxes-title-text-label-treatment'}>{title} {treatmentIndex + 1}</label>
                    {isExpanded &&<SvGraphics className={"delete-icon-treatment"} width={'20px'} height={'20px'}
                                              onClick={(e) => this.DeleteTreatment(e,treatmentIndex)} svgname={'delete-icon'}/>}
                    {isExpanded && <SvGraphics className={"patient-onboard-arrow-rotate-treatment"} width={'20px'} height={'20px'}
                                               svgname={'arrow-down'}
                                               onClick={() => this.onClickArrow()}/>
                    }
                </div>

                <div className={'patientsFormBoxes-title-board'} style={{display: isExpanded ? 'none' : 'flex'}} onClick={(e)=>this.onClickArrow(e)}>

                    {symptomsInfo}
                    <SvGraphics className={"delete-icon-treatment"}
                                onClick={(e) => this.DeleteTreatment(e,treatmentIndex)} svgname={'delete-icon'}/>

                    <SvGraphics svgname={'pencil'} className={"patient-onboard-arrow"}
                                width={'20px'} height={'20px'} onClick={() => this.onClickArrow()}/>

                </div>

                {isExpanded && <Component {...rest} />
                }
                {isExpanded && <div className={'treatment-approved'} onClick={()=>this.setState({isExpanded:!isExpanded})}>{t('patient_boarding.approve_finish')}</div>
                }

            </div>
        )
    }
}

TreatmentPlanNotExpanded.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default TreatmentPlanNotExpanded;
